import { ca } from '@cian/analytics';

/**
 * @description Событие: изменён фильтр в блоке проектов ПИК.
 */
export function trackPikProjectsFilterChange(field: string, value: string): void {
  ca('eventSite', {
    action: 'change_pik_projects_filter',
    category: 'Promo',
    label: `${field}:${value}`,
    name: 'oldevent',
    useLastProducts: true,
  });
}
